// ── Entry Point ───────────────────────────────────────────────────────────
// Boot guard and init() call are handled inside init.ts at module scope,
// so simply importing it is enough to start the application.
import { installLayoutReadGuard } from './runtime/devGuards';

// Install the DEV-only layout-read canary before init runs, so even the
// first frame is covered. Production builds strip this entirely.
installLayoutReadGuard();

import './runtime/init';
